<template>
	<MobileShell>
		<slot />
	</MobileShell>
</template>

<script setup>
import MobileShell from "~/components/layout-shell/MobileShell.vue";
</script>
